import { useState, modalHandler, useCallback, danger, success, swal } from "@";
import { saveNote, setAsPaid, saveRejectBankTransfer } from "./api";

export const useDonationsOperations = (setData, fetchData) => {
  // State to hold the data of the modal
  const [modalData, setModalData] = useState({});
  // State to manage loading state for adding order notes
  const [noteLoading, setNoteLoading] = useState(false);

  // Function to show the modal with the given row data
  const show = useCallback(
    (row) => {
      setModalData(row);
      modalHandler();
    },
    [setModalData],
  );

  // Function to update the notes in the modal data
  const noteChange = useCallback(
    (newNote) => {
      setModalData((prevData) => ({
        ...prevData,
        notes: newNote,
      }));
    },
    [setModalData],
  );

  // Function to save the notes of the order
  const addOrderNotes = useCallback(
    async (e) => {
      e.preventDefault();
      if (!modalData?.notes) {
        danger("يجب كتابة الملاحظات");
        return;
      }
      setNoteLoading(true);
      try {
        await saveNote(modalData);
        setData((prevData) =>
          prevData.map((item) =>
            item.id === modalData.id
              ? { ...item, notes: modalData.notes }
              : item,
          ),
        );
        setModalData({});
        modalHandler();
        success("تم الحفظ");
      } catch (error) {
        danger("حدث خطأ أثناء الحفظ");
      } finally {
        setNoteLoading(false);
      }
    },
    [modalData, setData],
  );

  // Function to save the notes of the order
  const editBankTransferSuccess = useCallback(async () => {
    setModalData({});
    modalHandler();
    fetchData();
  }, [fetchData]);

  // Function to set the order as paid
  const setPaid = useCallback(
    async (id) => {
      const { isConfirmed } = await swal(
        "هل أنت متأكد؟",
        "لن تكون قادرًا على إعادة هذا",
        "نعم تغير الى مدفوعة",
      );
      if (isConfirmed) {
        try {
          await setAsPaid(id);
          setData((prevData) =>
            prevData.map((item) =>
              item.id === id ? { ...item, isPaid: true, orderStatus: 0 } : item,
            ),
          );
          success("تم تغير الحالة الى مدفوعة");
        } catch (error) {
          danger("حدث خطأ أثناء تغيير الحالة");
        }
      }
    },
    [setData],
  );

  // Function to reject the bank transfer for the order
  const rejectBankTransfer = useCallback(
    async (id) => {
      const { isConfirmed } = await swal(
        "هل أنت متأكد؟",
        "لن تكون قادرًا على إعادة هذا",
        "نعم رفض الحوالة البنكية",
      );
      if (isConfirmed) {
        try {
          await saveRejectBankTransfer(id);
          setData((prevData) =>
            prevData.map((item) =>
              item.id === id ? { ...item, orderStatus: 3 } : item,
            ),
          );
          success("تم رفض الحوالة البنكية");
        } catch (error) {
          danger("حدث خطأ أثناء رفض الحوالة البنكية");
        }
      }
    },
    [setData],
  );

  return {
    show,
    setPaid,
    modalData,
    noteChange,
    noteLoading,
    addOrderNotes,
    rejectBankTransfer,
    editBankTransferSuccess,
  };
};
